<template lang="pug">
    .popups
        transition(name="fade")
            component(:is="popup")
</template>

<script>
    import Subscribe from "@/components/popups/Subscribe";
    export default {
        name: "Popup",
        computed:{
            popup(){
                return this.$store.state.popup;
            }
        },
        watch:{
            popup(popup){
                if (popup){
                    this.$store.commit('pageHidden')
                } else{
                    this.$store.commit('pageDelHidden')
                }
            }
        },
        components: {
            Subscribe,
        },
    }
</script>

<style scoped lang="scss">

</style>
